//document ready
$(function() {
  utils.enableDisclosure();
  var oldFlickityCreate = window.Flickity.prototype._create;

  window.Flickity.prototype._create = function(){
    var that = this;
    if(this.element.addEventListener){
      this.element.addEventListener('load', function(){
        that.onresize();
      }, true);
    }
    this._create = oldFlickityCreate;
    return oldFlickityCreate.apply(this, arguments);
  };

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', function(e){
    var bg = e.target.getAttribute('data-bg');

    if(bg){
        e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });

  // Call to flickity fix for sliders on IOS
  imageFunctions.flickityIosFix();

  objectFitImages();
  header.init();
  if (Shopify.theme_settings.enable_autocomplete){
    searchAutocomplete.init();
  }
  utils.pageBannerCheck();
  slideshow.init();
  testimonial.init();
  videoSection.init();
  gallery.init();
  videoFeature.setupVideoPlayer();
  featuredPromotions.init();
  featuredCollectionSection.init();
  collectionSidebarFilter.init();
  cart.init();
  mapFunction.init();
  productPage.init();
  recentlyViewed.init();

  if (Currency.show_multiple_currencies || Currency.native_multi_currency) {
    currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  var pathname = location.pathname;

  // If the pathname starts with '/challenge', animate scroll
  if(pathname.startsWith('/challenge')) {
    if (window.disableStickyHeader) window.disableStickyHeader();
    $('html, body').animate({
      scrollTop: 0
    }, 'slow', function() {
      if (window.enableStickyHeader) window.enableStickyHeader();
    });
  }

  // Product review scroll
  utils.productReviewScroll();

  // Setup a timer
  var resizeTimeout;
  // Grab screen width before screen is resized
  var beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', function ( event ) {

    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if ( !resizeTimeout ) {
      resizeTimeout = setTimeout(function() {

        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        var currentScreenWidth = $(window).width();
        // Run our resize functions
        if(Shopify.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          cart.init();
        }

      }, 66);
    }
  }, false);

  //Lightbox default options
  //https://fancyapps.com/fancybox/3/docs/#options
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function(instance, slide) {
    if (instance.current.type == 'image'){
      slide.$content.wrapInner( "<div class="fancybox-image-wrap"></div>" )
    }
    if (instance.group.length > 1){
      slide.$content.find('.fancybox-image-wrap').append('<a title="Anteriormente" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev=""><span>'+ svgArrowSizeLeft +'</span></a><a title="Siguiente" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next=""><span>'+ svgArrowSizeRight +'</span></a>')
    }
  }

  //backwards compatibility with custom lightboxes
  $('.lightbox[rel="gallery"]').fancybox();

  // Find youtube and vimeo iframes
  var $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    var ratio = width / height;

    //Determine ratio to be used
    if(Math.abs( ratio - 1 / 1 ) == 0) {
      return '1:1';
    } else {
      return ( Math.abs( ratio - 4 / 3 ) < Math.abs( ratio - 16 / 9 ) ) ? '4:3' : '16:9';
    }
  }

  $videoIframes.each(function(index, iframe) {

    // Update selector
    var $iframe = $(iframe);

    // Grab src
    var source = $iframe.attr('src');

    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap('<div class="lazyframe" data-ratio="'+ getAspectRatio($iframe.attr('width'), $iframe.attr('height'))  +'" data-src="' + source + '"></div>');
    }
  })

  // Iniciar lazyframe
  lazyframe('.lazyframe');

  // Envolver la política de shopify en las clases de diseño de la rejilla
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Evitar el solapamiento de cabeceras en las páginas de políticas generadas dinámicamente. Añade la etiqueta pagecontent para que coincida con la estructura actual de la página.
  $('.shopify-policy__container').closest('.section').prepend('<a name="pagecontent" id="pagecontent"></a>');

  /Añadir clases para determinar el tamaño de las columnas
  $('.shopify-policy__container').addClass('cinco octavos offset-por-tres columnas is-hidden-offset-mobile-only medium-down--one-whole');

  /Añadir separador destacado bajo el título de la página
  $('.shopify-policy__title').append('<div class="feature_divider"></div>');

  //Search input hiding
  //get current input
  var currentValue = $(".search__form input[name='q']").val()
  //return amount without *
  if ($(".search__form input[name='q']").length > 0){
    $(".search__form input[name='q']").val( currentValue.replace('*', '') );
  }

  $('#sort-by').val($('#sort-by').data('default-sort'));

  $('body')
    .on('change', '#sort-by', function() {
      quickFilter.init();
  });

  $('body')
    .on('change', '#tag_filter', function() {
      $('[data-option-filter] input').prop('checked', false);
      quickFilter.init();
  });

  $('body')
    .on('change', '#blog_filter', function() {
      var url = $(this).val();
      window.location = url;
  });

  $('input, select, textarea').on('focus blur', function(event) {
    $('meta[name=viewport]').attr('content', 'width=device-width,initial-scale=1,maximum-scale=' + (event.type == 'blur' ? 10 : 1));
  });

  //Collection sidebar filter
  //Check the checkbox values
  $('body').on('change', '[data-option-filter] input', function(){
    quickFilter.init();
    if (window.disableStickyHeader) window.disableStickyHeader();
    $("html, body").animate({
      scrollTop: ($('#pagecontent').offset().top)
    }, 500, function() {
      if (window.enableStickyHeader) window.enableStickyHeader();
    });
  })

  $('body').on('click', '[data-reset-filters]', function(){
    collectionSidebarFilter.clearAllFilters();
  });

  $('body').on('click', '[data-clear-filter]', function(){
    var selectedOption = $(this).parents('.filter-active-tag');
    collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });

  $('body').on('change', '.currencies', function(e) {
      $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });

  $('body').on('change', '.js-quick-shop select', function(e) {
      var currentVariant = $('.js-quick-shop select[name="id"]').val();
      if (currentVariant && globalQuickShopProduct){
        quickShop.updateVariant(currentVariant);
      }
  });

  if (Shopify.theme_settings.quick_shop_enabled){
    quickShop.init();
  }

  var touchStartPos = 0;

  //Detecting swipe vs tap
  $(document).bind("touchstart", function (e) {
    touchStartPos = $(window).scrollTop();
  }).bind("touchend", function (e) {
      var distance = touchStartPos - $(window).scrollTop();
      if (distance > 20 || distance < -20) {
          e.preventDefault;
      }
  });

  $('body').on('click', '.sidebar .parent-link--false', function(e) {
    e.preventDefault();
    $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });

  if (Shopify.theme_settings.newsletter_popup){
    newsletter_popup.init();
  }

  if(window.location.pathname.indexOf('/comments') != -1) {
    if (window.disableStickyHeader) window.disableStickyHeader();
    $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow', function() {
      if (window.enableStickyHeader) window.enableStickyHeader();
    });
  }

  $('body').on('mouseenter', '.icon-search', function() {
    $('.search-terms').focus();
  });

  $('body').on('click', '.icon-search', function() {
    $('input.search-terms').focus();
  });

  $('body').on('click', '.search-submit', function() {
    $(this).parent().submit();
  });

  if (Shopify.media_queries.large.matches) {
    $(".animate_right").waypoint(function() {
      $(this.element).addClass("animated fadeInRight");
    }, { offset: '70%' });
    $(".animate_left").waypoint(function() {
      $(this.element).addClass("animated fadeInLeft");
    }, { offset: '70%' });
    $(".animate_up").waypoint(function() {
      $(this.element).addClass("animated fadeInUp");
    }, { offset: '70%' });
    $(".animate_down").waypoint(function() {
      $(this.element).addClass("animated fadeInDown");
    }, { offset: '70%' });
  }

  //backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: usePageDots,
    imagesLoaded: true,
    arrowShape: arrowSize,
    lazyLoad: 2
  });

  utils.createAccordion('.toggle-all--true', 'h4.toggle', 'ul.toggle_list');
  utils.createAccordion('.footer_menu', 'h6', 'ul');
  utils.createAccordion('.footer_content', 'h6', 'div.toggle_content');
  utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');

  utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span', 'li.sublink ul');
  utils.mobileAccordion('#mobile_menu', 'li.sublink > a.parent-link--false', 'li.sublink ul');

  utils.initializeTabs();
  utils.resizeActionButtons();
  globalAccordions.init();

  $(window).on('resize', function() {
    utils.resizeActionButtons();
  });

  //Sidebar toggle check
  if (Shopify.media_queries.medium.matches) {
    utils.createAccordion('.toggle-all--false', 'h4.toggle', 'ul.toggle_list');
  }

  $('body').on('click', '.menu-toggle', function(e) {
    var $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') == 'true' ? 'false' : 'true');
  });

  if (Shopify.theme_settings.collection_swatches){
    if (Shopify.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function() {
        $('.swatch span', $(this)).each(function() {
          if($(this).data("image").indexOf("no-image") == -1) {
            $('<img>')[0].src = $(this).data("image");
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function() {
        if($(this).data("image").indexOf("no-image") == -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data("image"));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data("image"));
        }
      });
    }
  }

  //Terms of service settings for minicart
  if (Shopify.theme_settings.display_tos_checkbox){
    $('body').on('click touchstart', '.cart_content .tos_label', function() {
      $(this).prev('input').prop('checked', true);
    });
  }

  if (Shopify.theme_settings.display_tos_checkbox && Shopify.theme_settings.go_to_checkout){
    //Terms of service on mini-cart && cart page
    $('body').on('click', ".tos_warning .action_button", function(e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (Shopify.theme_settings.go_to_checkout || $('body').hasClass('cart')){
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = "/cart";
        }
      } else {
        var warning = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + '</p>';
        if ($('p.warning').length == 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!Shopify.theme_settings.go_to_checkout){
    $('body').on('click', ".cart_content .action_button", function(e) {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = Shopify.routes.cart_url;
    });
  }


  if (Shopify.theme_settings.collection_secondary_image){
    imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length){
    var $checkboxGroup = $('.contact-block--checkbox input');
    $checkboxGroup.prop('required', true);

    $('.contact-block--checkbox [data-is-required] input').on('change', function(){
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(":checked")) {
        $checkboxGroup.prop('required', false);
      }
    })
  }

  $('.maps').click(function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  if (Shopify.theme_settings.pagination_type == 'load_more_button' ){
    enableLoadMoreButton('.collection-matrix');
  }

  if (Shopify.theme_settings.pagination_type == 'load_more' ){
    enableLoadMoreProducts();
  }

  if (Shopify.theme_settings.pagination_type == 'infinite_scroll'){
    enableInfiniteScroll();
  }

  if (Shopify.theme_settings.search_pagination_type == 'load_more_button' ){
    enableLoadMoreButton('.search-matrix');
  }

  if (Shopify.theme_settings.search_pagination_type == 'load_more' ){
    enableLoadMoreSearch();
  }

  if (Shopify.theme_settings.search_pagination_type == 'infinite_scroll' ){
    enableInfiniteSearchScroll();
  }

  /*============================================================================
    Start of cart-related functionality
  ==============================================================================*/

  function ajaxSubmitCart(cart) {
    $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success: function (data) {
        refreshCart(data);
      }
    });
  }

  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success: function (data) {

        var cartItemsArray = data.items;
        var lineIDIndex = cartItem.lineID - 1;
        var totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        var $quantityInputs = cartItem.parentCartForm.find('[data-variant-id="' + cartItem.variantID + '"] input');
        var initialQuantityTotal = 0;
        var apiQuantityTotal = 0;
        var apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, function (i, input) {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(function (item) {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          })
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        //Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal == 1) {
            items_left_text = Shopify.translation.one_item_left;
          } else {
            items_left_text = Shopify.translation.items_left_text;
          }

          $('.warning--quantity').remove();

          //Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {

            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            var warning = '<p class="warning warning--quantity animated bounceIn">' + apiQuantityTotal + ' ' + items_left_text + '</p>';
            cartItem.parentCartForm.find("[data-line-id='" + cartItem.lineID + "'] input").parent().after(warning);
            cartItem.parentCartForm.find("[data-line-id='" + cartItem.lineID + "'] input").val(apiLineItemQuantity);
          }

        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      }
    });
  }

  function refreshCartID() {
    var cartItem = document.querySelectorAll('.cart__item');

    for(var i = 0; i < cartItem.length; i++) {
      var lineIndex = i + 1;
      var dataLineId = cartItem[i].querySelectorAll('[data-line-id]');

      for(var c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }

  function refreshCart(cart) {
    $(".cart_count").empty();
    $cartBtn = $(".cart_count");
    var value = $cartBtn.text() || '0';
    var cart_items_html = "";
    var cart_discounts_html = "";
    var cart_action_html = "";
    var cart_savings_html = "";
    var $cart_form = $('[data-cart-form]');
    var productHasSale = false;
    var productCompareAtPrice = 0;
    var productFinalPrice = 0;

    $cart_form.data('total-discount', cart.total_discount);

    $cartBtn.text(value.replace(/[0-9]+/,cart.item_count));

    if (cart.item_count == 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cart_form.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cart_form.removeClass('hidden');

      var total_saving = 0; // adding counter variables for total cart savings
      var saving = 0;

      $.each(cart.items, function(index, item) {
        var itemDiscounts = item.discounts;
        var discountMessage = "";

        for (i=0; i < itemDiscounts.length; i++) {
          var amount = Shopify.formatMoney(itemDiscounts[i].amount, $('body').data('money-format'));
          var title = itemDiscounts[i].title;
          discountMessage = '<p class="notification-discount meta">' + título + '</p>';
        }
        var line_id = índice + 1;

        cart_items_html += '<li class="mini-cart__item clearfix" data-cart-item="" data-cart-item-key="' + item.key + '" data-line-id="' + line_id + '" data-variant-id="' + item.id + '">' +
          '<a href="' + item.url +'">';
        if (item.image) {
          cart_items_html += '<div class="cart_image">' +
              '<img src="' + item.image.replace(/(\.[^.]*)$/, " _compact$1").replace('http:',="" '')="" +="" '"="" alt="' + htmlEncode(item.title) + '">' +
            '</div></a>';
        }

        cart_items_html += '<div class="mini-cart__item--content"><div class="mini-cart__item__title"><div class="item_title"><a href="' + item.url + '">' + item.title + '</a></div>';

        if(item.properties) {
          $.each(item.properties, function(title, value) {
            if (value) {
              cart_items_html += '<div class="line-item">' + title +': ' + value + ' </div>';
            }
          });
        }

        cart_items_html += '<strong class="right price">';

        $.ajax({
          dataType: "json",
          async: false,
          cache: false,
          url: "/products/" + item.handle + ".js",
          success: function(data) {
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (data.variants) {
              var itemVariants = data.variants;
              if (itemVariants.length > 1) {
                for (v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id == item.id) {
                    var data = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (data.compare_at_price) {
              if(data.compare_at_price > data.price) {
                productHasSale = true;
                productCompareAtPrice = data.compare_at_price;
                productFinalPrice = data.price;
              }
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          }
        });

        if(productHasSale == true) {
          //puts the slash through the old item price
          var itemPrice = Shopify.formatMoney(productFinalPrice, $('body').data('money-format')) + ' <span class="money was_price">' + Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format')) + '</span>';
          cart_items_html += '<span class="money sale">' + itemPrice + '</span></strong>';

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          total_saving = saving + total_saving;
        } else {
          if (item.price > item.final_price) {
            //puts the slash through the old item price
            var itemPrice = Shopify.formatMoney(item.final_price, $('body').data('money-format')) + ' <span class="money was_price">' + Shopify.formatMoney(item.price, $('body').data('money-format'))) + '</span>';
            cart_items_html += '<span class="money sale">' + itemPrice + '';
          } else {
            var itemPrice = Shopify.formatMoney(item.price, $('body').data('money-format'));
            cart_items_html += '<span class="money">' + itemPrice + '</span>';
          }
        }

        if (item.price > item.final_price) {
          cart_items_html += discountMessage;
        }

        cart_items_html += '<div class="left product-quantity-box">';
        cart_items_html += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cart_items_html += '<input type="number" min="0" class="quantity" name="updates[]" id="updates_' + item.id + '" value="' + item.quantity + '" data-cart-quantity-input="mini-cart">';
        cart_items_html += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cart_items_html += '</div></span></div></div>';
        cart_items_html += '<a href="/cart/change?line=' + line_id + '&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="' + line_id + '" data-remove-item="mini-cart"><span class="remove-icon"></span></a>';

      });

      var cartDiscounts = cart.cart_level_discount_applications;
      var cartDiscountMessage = "";

      for (i=0; i < cartDiscounts.length; i++) {
        var amount = Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        var title = cartDiscounts[i].title;

        cart_discounts_html += '<span class="cart_discounts--title">' + título + '</span>';
        cart_discounts_html += '<span class="cart_discounts--price">';
        cart_discounts_html += '-<span class="money">' + importe +</span> '</span>';
      }

      cart_action_html += '<span class="right"><span class="money">' + Shopify.formatMoney(cart.total_price, $('body').data('money-format'))) + '</span></span>' + '<span>' + Shopify.translation.cart_subtotal_text + '</span>';
      total_saving = total_saving + cart.total_discount;
      if(Shopify.theme_settings.display_savings && total_saving > 0) {
        cart_savings_html = '<span class="right"><span class="money">' + Shopify.formatMoney(ahorro_total, $('body').data('formato-dinero'))) + '</span></span>' +
            '<span>' + Shopify.translation.cart_savings_text + '</span>';
      } else {
        cart_savings_html = "";
      }
    }

    $('.js-cart_items').html(cart_items_html);
    $('.js-cart_discounts').html(cart_discounts_html);
    $('.js-cart_subtotal').html(cart_action_html);
    $('.js-cart_savings').html(cart_savings_html);
	
    document.dispatchEvent(new CustomEvent('limoniapps:discountninja:drawercart:opened'));
    
    // Converting the currencies
    if (Currency.show_multiple_currencies) {
      currencyConverter.convertCurrencies();
    }
    
    document.addEventListener("limoniapps:discountninja:drawercart:refreshed", function (event) { var cart = event.detail.data[0]; refreshCart(cart); });

  }

  $('body').on('change', '[data-cart-quantity-input]', function() {
    var cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element : $(this).parents('[data-cart-item]')
    }
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });

  $('body').on('click', '[data-remove-item]', function(e) {
    e.preventDefault();
    var cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element : $(this).parents('[data-cart-item]')
    }
    cartItem.$element.addClass('animated fadeOutLeft');

    updateCartItemQuantity(cartItem);

    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }

    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });

  if (Shopify.theme_settings.cart_action == 'ajax'){
    $(document).on('click', '.ajax-submit', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this).closest('form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      //Refresh page on quick shop add to cart if on cart page
      if($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("fadeInDown").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              setTimeout(function() {
                refreshCart(cart);
                if($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }

                if($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                //block scrolling on mobile
                if (Shopify.media_queries.medium.matches) {
                  var $cart_container = $(this).parent();
                  if($cart_container.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }
                }
              }, 500)
            }
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('Todos 1 ', 'Todos ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(Shopify.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
  }

  productPage.productSwatches();

});

/*============================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
==============================================================================*/
Shopify.updateOptionsInSelector = function(selectorIndex, parent) {

  switch (selectorIndex) {
    case 0:
      var key = 'root';
      var selector = $(parent + ' .single-option-selector:eq(0)');
      break;
    case 1:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      var selector = $(parent + ' .single-option-selector:eq(1)');
      break;
    case 2:
      var key = $(parent + ' .single-option-selector:eq(0)').val();
      key += ' / ' + $(parent + ' .single-option-selector:eq(1)').val();
      var selector = $(parent + ' .single-option-selector:eq(2)');
  }

  var availableOptions = Shopify.optionsMap[key];
  $(parent + ' .swatch[data-option-index="' + selectorIndex + '"] .swatch-element').each(function() {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');
    }
    else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled','disabled');
    }
  });

};

Shopify.linkOptionSelectors = function(product, parent) {
    // Building our mapping object.
    Shopify.optionsMap = {};
    for (var i=0; i<product.variants.length; i++)="" {="" var="" variant="product.variants[i];" if="" (variant.available)="" Gathering="" values="" for="" the="" 1st="" drop-down.="" Shopify.optionsMap['root']="Shopify.optionsMap['root']" ||="" [];="" Shopify.optionsMap['root'].push(variant.option1);="" 2nd="" (product.options.length=""> 1) {
          var key = variant.option1;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option2);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
        // Gathering values for the 3rd drop-down.
        if (product.options.length === 3) {
          var key = variant.option1 + ' / ' + variant.option2;
          Shopify.optionsMap[key] = Shopify.optionsMap[key] || [];
          Shopify.optionsMap[key].push(variant.option3);
          Shopify.optionsMap[key] = Shopify.uniq(Shopify.optionsMap[key]);
        }
      }
    }
    // Update options right away.
    Shopify.updateOptionsInSelector(0, parent);
    if (product.options.length > 1) Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
    // When there is an update in the first dropdown.
    $(parent + " .single-option-selector:eq(0)").change(function() {
      Shopify.updateOptionsInSelector(1, parent);
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
    // When there is an update in the second dropdown.
    $(parent + " .single-option-selector:eq(1)").change(function() {
      if (product.options.length === 3) Shopify.updateOptionsInSelector(2, parent);
      return true;
    });
};

//Used for cart functionality
function htmlEncode(value){
    if (value) {
        return $('<div></div>').text(value).html();
    } else {
        return '';
    }
}

//Check if device is touch-enabled
function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

//Differentiate between mobile and touch screen laptops
var touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

/* option_selection.js */
function floatToString(t,e){var o=t.toFixed(e).toString();return o.match(/^\.\d+/)?"0"+o:o}if("undefined"==typeof Shopify)var Shopify={};Shopify.each=function(t,e){for(var o=0;o<t.length;o++)e(t[o],o)},shopify.map=function(t,e){for(var 0="=e[o]?null:e[o]});return" 1="=i?void(e=o):void" o="[],i=0;i<t.length;i++)o.push(e(t[i],i));return" o},Shopify.arrayIncludes="function(t,e){for(var" e="[],o=0;o<t.length;o++)Shopify.arrayIncludes(e,t[o])||e.push(t[o]);return" e},Shopify.isDefined="function(t){return&quot;undefined&quot;==typeof" t?!1:!0},Shopify.getClass="function(t){return" Object.prototype.toString.call(t).slice(8,-1)},Shopify.extend="function(t,e){function" o(){}o.prototype="e.prototype,t.prototype=new" o,t.prototype.constructor="t,t.baseConstructor=e,t.superClass=e.prototype},Shopify.locationSearch=function(){return" window.location.search},Shopify.locationHash="function(){return" window.location.hash},Shopify.replaceState="function(t){window.history.replaceState({},document.title,t)},Shopify.urlParam=function(t){var" e&&decodeURIComponent(e[1].replace(="" \+="" g,"="" "))},Shopify.newState="function(t,e){var" o;return="" in="" t)this[property]="t[property]},Shopify.Product.prototype.optionNames=function(){return&quot;Array&quot;==Shopify.getClass(this.options)?this.options:[]},Shopify.Product.prototype.optionValues=function(t){if(!Shopify.isDefined(this.variants))return" null;var="" +(t+1);return="" void="" null="=e[0]?null:Shopify.uniq(e)},Shopify.Product.prototype.getVariant=function(t){var" t.length!="this.options.length?e:(Shopify.each(this.variants,function(o){for(var" i="!0,r=0;r<t.length;r++){var" n="option" +(r+1);o[n]!="t[r]&&(i=!1)}return" 0}),e)},Shopify.Product.prototype.getVariantById="function(t){for(var" o}return="" null},Shopify.money_format="$" ,Shopify.formatMoney="function(t,e){function" o(t,e){return"undefined"="=typeof" t?e:t}function="" i(t,e,i,r){if(e="o(e,2),i=o(i,&quot;,&quot;),r=o(r,&quot;.&quot;),isNaN(t)||null==t)return" 0;t="(t/100).toFixed(e);var" a+s}"string"="=typeof" t&&(t="t.replace(&quot;.&quot;,&quot;&quot;));var" r="" ,n="/\{\{\s*(\w+)\s*\}\}/,a=e||this.money_format;switch(a.match(n)[1]){case&quot;amount&quot;:r=i(t,2);break;case&quot;amount_no_decimals&quot;:r=i(t,0);break;case&quot;amount_with_comma_separator&quot;:r=i(t,2,&quot;.&quot;,&quot;,&quot;);break;case&quot;amount_with_apostrophe_separator&quot;:r=i(t,2,&quot;'&quot;,&quot;.&quot;);break;case&quot;amount_no_decimals_with_comma_separator&quot;:r=i(t,0,&quot;.&quot;,&quot;,&quot;)}return" a.replace(n,r)},Shopify.OptionSelectors="function(t,e){return" this.selectorDivClass="selector-wrapper" ,this.selectorClass="single-option-selector" ,this.variantIdFieldIdSuffix="-variant-id" ,this.variantIdField="null,this.historyState=null,this.selectors=[],this.domIdPrefix=t,this.product=new" Shopify.Product(e.product),this.onVariantSelected="Shopify.isDefined(e.onVariantSelected)?e.onVariantSelected:function(){},this.replaceSelector(t),this.initDropdown(),e.enableHistoryState&&(this.historyState=new" Shopify.OptionSelectors.HistoryState(this)),!0},Shopify.OptionSelectors.prototype.initDropdown="function(){var" t="{initialLoad:!0},e=this.selectVariantFromDropdown(t);if(!e){var" this.selectVariant(o,t)},Shopify.OptionSelectors.prototype.selectVariantFromParams="function(t){var" this.selectVariant(e,t)},Shopify.OptionSelectors.prototype.selectVariant="function(t,e){var" jQuery?jQuery(this.selectors[0].element).trigger("change",e):this.selectors[0].element.onchange(e),!0},Shopify.OptionSelectors.prototype.optionExistInSelect="function(t,e){for(var" Shopify.SingleOptionSelector(this,t,this.product.optionNames()[t],this.product.optionValues(t));e.element.disabled="!1,this.selectors.push(e)}var">1){var r=document.createElement("label");r.htmlFor=t.element.id,r.innerHTML=t.name,e.appendChild(r)}return e.appendChild(t.element),e});return r},Shopify.OptionSelectors.prototype.selectedValues=function(){for(var t=[],e=0;e<this.selectors.length;e++){var o="this.selectors[e].element.value;t.push(o)}return" t},Shopify.OptionSelectors.prototype.updateSelectors="function(t,e){var" i="/" ;var="" r="document.getElementById(t),n=r.childNodes,a=(r.parentNode,e.length),s=[];Shopify.each(n,function(t,r){if(1==t.nodeType&&&quot;option&quot;==t.tagName.toLowerCase()){var" n="t.innerHTML.split(new" RegExp("\\s*\\"+i+"\\s*"));0="=e.length&&(a=n.length-(o?1:0));var" p="n.slice(0,a),l=o?n[a]:&quot;&quot;,c=(t.getAttribute(&quot;value&quot;),{available:t.disabled?!1:!0,id:parseFloat(t.value),price:l,option1:p[0],option2:p[1],option3:p[2]});s.push(c)}});var" l="0;a">l;l++)p.options[l]="option "+(l+1)}else p.options=e;return p},Shopify.SingleOptionSelector=function(t,e,o,i){this.multiSelector=t,this.values=i,this.index=e,this.name=o,this.element=document.createElement("select");for(var r=0;r<i.length;r++){var n="document.createElement(&quot;option&quot;);n.value=i[r],n.innerHTML=i[r],this.element.appendChild(n)}return" this.element.setAttribute("class",this.multiSelector.selectorClass),this.element.setAttribute("data-option","option"+(e+1)),this.element.id="t.domIdPrefix+&quot;-option-&quot;+e,this.element.onchange=function(o,i){i=i||{},t.updateSelectors(e,i)},!0},Shopify.Image={preload:function(t,e){for(var" o="0;o<t.length;o++){var" i="t[o];this.loadImage(this.getSizedImageUrl(i,e))}},loadImage:function(t){(new" Image).src="t},switchImage:function(t,e,o){if(t&&e){var" e="t.match(/_(1024x1024|2048x2048|pico|icon|thumb|small|compact|medium|large|grande)\./);return" null!="e?e[1]:null},getSizedImageUrl:function(t,e){if(null==e)return" t;if("master"="=e)return" this.removeProtocol(t);var="" this.removeProtocol(i[0]+"_"+e+r)}return="" null},removeProtocol:function(t){return="" t.replace(="" http(s)?:="" ,"")}},Shopify.OptionSelectors.HistoryState="function(t){this.browserSupports()&&this.register(t)},Shopify.OptionSelectors.HistoryState.prototype.register=function(t){window.addEventListener(&quot;popstate&quot;,function(e){t.selectVariantFromParamsOrDropdown({popStateCall:!0})})},Shopify.OptionSelectors.HistoryState.prototype.onVariantChange=function(t,e,o){this.browserSupports()&&(!t||o.initialLoad||o.popStateCall||Shopify.setParam(&quot;variant&quot;,t.id))},Shopify.OptionSelectors.HistoryState.prototype.browserSupports=function(){return" window.history&&window.history.replaceState};="" $(document)="" .on('shopify:block:select',="" function(e){="" var="" blockId="e.detail.blockId;" $parentSection="$('#shopify-section-'" +="" e.detail.sectionId);="" if="" ($parentSection.hasClass('shopify-section--slideshow')="" ||="" $parentSection.hasClass('shopify-section--testimonials'))="" {="" sliderBlock.select(blockId,="" $parentSection);="" }="" ($parentSection.find('.block__recommended_products'))="" productPage.unload($parentSection);="" productPage.init();="" if($parentSection.hasClass('shopify-section--product-details-template'))="" if($('.shopify-section--map').length)="" mapFunction.init();="" if($('.shopify-section--featured-collection').length)="" featuredCollectionSection.init();="" videoFeature.init();="" ($('shopify-section--video').length)="" videoSection.init();="" if($('.recently-viewed__section').length="" &&="" Shopify.theme_settings.collection_secondary_image)="" imageFunctions.showSecondaryImage();="" if($parentSection.hasClass('shopify-section--page-details-template'))="" ($parentSection.hasClass('shopify-section--cart-template'))="" ($('.block__featured_collection').length){="" ($parentSection.hasClass('shopify-section--product-template'))="" (Shopify.theme_settings.enable_shopify_review_comments){="" if($('#shopify-product-reviews').length="">= 1) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      }
    }

    utils.resizeActionButtons();

});

$(document)
  .on('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--slideshow') || $parentSection.hasClass('shopify-section--testimonials')) {
      sliderBlock.deselect($parentSection);
    }
});

$(document)
  .on('shopify:section:reorder', function(e){

    utils.pageBannerCheck();

});

$(document)
  .on('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    utils.pageBannerCheck();
    utils.enableDisclosure();

    if (Shopify.theme_settings.enable_autocomplete) {
      searchAutocomplete.init();
    }

    if (Shopify.theme_settings.newsletter_popup) {
      newsletter_popup.init();
    }

    if ($parentSection.hasClass('shopify-section--page-gallery-template')) {
      gallery.init($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--gallery')) {
      gallery.init();
    }

    if ($parentSection.hasClass('shopify-section--page-faq-template') || $parentSection.hasClass('shopify-section--faq')) {
      globalAccordions.init();
    }

    if ($parentSection.hasClass('shopify-section--cart-template')) {
      cart.init();

      if ($('.block__featured_collection').length) {
        featuredCollectionSection.init();
      }
    }

    if ($parentSection.hasClass('shopify-section--featured-promotions')) {
      featuredPromotions.init();
    }

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      slideshow.init();
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      testimonial.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-products')) {
      productPage.init();
      videoFeature.init();
      productPage.productSwatches();
      if (Shopify.theme_settings.enable_shopify_review_comments){
        if($('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      }
    }

    if($parentSection.hasClass('shopify-section--map')) {
      mapFunction.init();
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      featuredCollectionSection.init();
      videoFeature.init();
    }

    if ($parentSection.hasClass('shopify-section--video')) {
      videoSection.init();
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      productPage.init();
      videoFeature.init();
      productPage.productSwatches();
      recentlyViewed.init();
      if (Shopify.theme_settings.enable_shopify_review_comments){
        if($('#shopify-product-reviews').length || $('.shopify-product-reviews-badge').length) {
          SPR.$(document).ready(function() {
            return SPR.registerCallbacks(),
            SPR.initRatingHandler(),
            SPR.initDomEls(),
            SPR.loadProducts(),
            SPR.loadBadges()
          })
        }
      }

      // Product review scroll
      utils.productReviewScroll();
    }

    if ($parentSection.hasClass('recommended-products-section')) {
      productPage.init();
    }

    if ($parentSection.hasClass('shopify-section--recently-viewed-products')) {
      recentlyViewed.init();
    }

    if ($parentSection.hasClass('shopify-section--article-template')) {
      if(window.location.pathname.indexOf('/comments') != -1) {
        if (window.disableStickyHeader) window.disableStickyHeader();
        $('html,body').animate({scrollTop: $("#new-comment").offset().top-140},'slow', function() {
          if (window.enableStickyHeader) window.enableStickyHeader();
        });
      }
    }

    if ($parentSection.hasClass('shopify-section--collection-template')) {
      collectionSidebarFilter.init();
      recentlyViewed.init();
    }

    if($parentSection.hasClass('shopify-section--contact-section')) {
      mapFunction.init();
    }

    if ($parentSection.hasClass('shopify-section--search-template')) {
      if (Shopify.theme_settings.enable_autocomplete){
        searchAutocomplete.init();
      }
      collectionSidebarFilter.init();
    }

    if ($parentSection.hasClass('shopify-section--header')) {
      header.init();
    }

    if ($parentSection.hasClass('shopify-section--page-details-template')) {
      featuredCollectionSection.init();
      videoSection.init();
      recentlyViewed.init();

      if($('.block__image_gallery').length) {
        gallery.init();
      };
    }

    if ($parentSection.hasClass('shopify-section--product-details-template')) {
      featuredCollectionSection.init();
      videoSection.init();
      mapFunction.init();
      if($('.block__image_gallery').length) {
        gallery.init();
      };
      recentlyViewed.init();
      productPage.init();
    }
});


$(document)
  .on('shopify:section:unload', function(e){
    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--slideshow')) {
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--testimonials')) {
      testimonial.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--search')) {
      searchAutocomplete.unload($target);
    }

    if ($parentSection.hasClass('shopify-section--product-template')) {
      productPage.unload($parentSection);
    }

    if ($parentSection.hasClass('shopify-section--featured-products')) {
      productPage.unload($parentSection);
    }
});

$(document)
  .on('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      setTimeout(function() {
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseenter');
        $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').addClass('editor-hover--true');
      }, 10);
    }

    if ($parentSection.hasClass('shopify-section--featured-collection')) {
      featuredCollectionSection.unload($parentSection);
      featuredCollectionSection.init();
    }

    utils.pageBannerCheck();
    var evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
});

$(document)
  .on('shopify:section:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('shopify-section--mega-menu')) {
      var megaMenuParent = $('.header .' + e.detail.sectionId).data('dropdown');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').trigger('mouseout');
      $('a.mega-menu-parent[data-dropdown-rel="' + megaMenuParent + '"]').parents('header').removeClass('editor-hover--true');
    }
});

jQuery( document ).ready( function(){
    var cart_disc_input = jQuery( '.limoniapps-discountninja-cartdiscountfield-wrapper .limoniapps-discountninja-cartdiscountfield-input' );
    cart_disc_input.prop( 'id', 'limoniapps_discountninja_cartdiscountfield' );
    cart_disc_input.prop( 'name', 'limoniapps_discountninja_cartdiscountfield' );
    cart_disc_input.before( '<label style="display:none;" for="limoniapps_discountninja_cartdiscountfield">Carrito de descuento</label>' );

    var vol_disc_radio = jQuery( '.limoniapps-discountninja-volumediscounts-tier .limoniapps-discountninja-volumediscounts-tier-radiobutton' );
    vol_disc_radio.prop( 'id', 'limoniapps-discountninja-volumediscounts' );
    vol_disc_radio.before( '<label style="display:none;" for="limoniapps-discountninja-volumediscounts">Descuentos por volumen</label>' );  
    
    var nf_interval = setInterval( nf_add_label_input, 500 );
    var nf_timeout  = 0;
    function nf_add_label_input() {
        var nf_form = jQuery( '.nf-form' );
        if( nf_form.length > 0 || nf_timeout > 20 ) {
            var nf_inputs = jQuery( '.nf-form input[type=text], .nf-form textarea' );
            nf_inputs.each( function(){
                var input_id = jQuery( this ).prop( 'id' );
                jQuery( this ).before( '<label style="display:none;" for="' + input_id + '">Etiqueta de entrada</label>' );
            });
            clearInterval( nf_interval );
        }else{
            nf_timeout++;
        }
    }
  
    var drip_form = jQuery( 'form#drip-ef-321722851' );
    if ( drip_form.length > 0 ) {
  	  drip_form.find( 'label[for=drip-email]' ).remove();
      drip_form.find( 'input#drip-email' ).unwrap().before( '<label style="display:none;" for="drip-email">Correo electrónico por goteo</label>' );
    }
  
    var slide_images = jQuery( '.shg-sld-slides img' );
    if( slide_images.length > 0 ){
  		slide_images.attr( 'alt', 'shogun-image' );
    }
  	
    var imgs = jQuery( "body img" );
    imgs.each( function( idx, val ){
      var alt_img = jQuery( this ).attr( 'alt' );

      // For some browsers, `attr` is undefined; for others,
      // `attr` is false.  Check for both.
      if ( typeof alt_img === 'undefined' || alt_img === false || alt_img == '' ) {
          jQuery( this ).attr( 'alt', 'emuaid-image' );
      }
    });
    
    var honeypot_interval = setInterval( add_honeypot_to_forms, 500 );
    var honeypot_timeout = 0;
    
    function add_honeypot_to_forms() {
        var target_forms = jQuery( 'form:not([action*="/cart/add"]):not([action*="/account"]):not([action*="checkout"]):not(.tmenu_search_form)' );
        
        if( target_forms.length > 0 || honeypot_timeout > 20 ) {
            target_forms.each( function(){
                var form = jQuery( this );
                
                if( form.hasClass( 'tmenu_search_form' ) || 
                    form.find( 'input[name="q"]' ).length > 0 || 
                    form.find( 'input[type="search"]' ).length > 0 ||
                    form.find( '.emuaid-honeypot' ).length > 0 ) {
                    return;
                }
                
                var is_cart_form = form.attr('action') && (form.attr('action').includes('/cart') && !form.attr('action').includes('/cart/add'));
                
                var honeypot_field = '<input type="text" name="website" class="emuaid-honeypot" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute!important;left:-9999px!important;top:-9999px!important;width:1px!important;height:1px!important;opacity:0!important;visibility:hidden!important;overflow:hidden!important;pointer-events:none!important;z-index:-1!important;border:0!important;padding:0!important;margin:0!important;">';
                
                var start_time = Date.now();
                var campo_tiempo = '<input type="hidden" name="form_start_time" value="' + start_time + '">';
                
                if( form.children().length > 0 ) {
                    form.prepend( honeypot_field + time_field );
                } else {
                    form.append( honeypot_field + time_field );
                }
                
                form.on( 'submit', function(e) {
                    var honeypot_value = form.find( '.emuaid-honeypot' ).val();
                    var current_time = Date.now();
                    var form_start = parseInt( form.find( 'input[name="form_start_time"]' ).val() );
                    var time_diff = current_time - form_start;
                    
                    if( honeypot_value && honeypot_value.trim() !== '' ) {
                        e.preventDefault();
                        
                        if( is_cart_form ) {
                            alert( 'Please refresh the page and try again.' );
                        }
                        return false;
                    }
                    
                    var min_time = is_cart_form ? 1000 : 2000;
                    if( time_diff < min_time ) {
                        e.preventDefault();
                        
                        if( is_cart_form ) {
                            alert( 'Please wait a moment and try again.' );
                        }
                        return false;
                    }
                });
            });
            
            clearInterval( honeypot_interval );
        } else {
            honeypot_timeout++;
        }
    }
    
});

window.addEventListener('load', function (event) {
	var grecaptcha_textarea = jQuery( '.grecaptcha-badge .g-recaptcha-response' );
    grecaptcha_textarea.each( function ( idx, value ) {
        var textarea_id = jQuery( this ).attr( 'id' );
        jQuery( this ).before( '<label style="display:none;" for="' + textarea_id + '">Recaptcha Textarea de Google</label>' );
    });

    var kl_form = jQuery( '.klaviyo-form-RpAUCj, .klaviyo-form-WfDchU' );
    kl_form.append('<span id="kl_email">&nbsp;</span><span id="preferences__4_label">&nbsp;</span>');
    
    var klaviyo_honeypot_interval = setInterval( add_klaviyo_honeypot, 500 );
    var klaviyo_honeypot_timeout = 0;
    
    function add_klaviyo_honeypot() {
        var klaviyo_forms = jQuery( '.klaviyo-form form, form[action*="klaviyo"], [data-testid="form-element"]' );
        
        if( klaviyo_forms.length > 0 || klaviyo_honeypot_timeout > 40 ) {
            klaviyo_forms.each( function(){
                var kl_form = jQuery( this );
                
                if( kl_form.find( '.emuaid-honeypot' ).length > 0 ) {
                    return;
                }
                
                var kl_honeypot = '<input type="text" name="website" class="emuaid-honeypot" tabindex="-1" autocomplete="off" aria-hidden="true" style="position:absolute!important;left:-9999px!important;top:-9999px!important;width:1px!important;height:1px!important;opacity:0!important;visibility:hidden!important;overflow:hidden!important;pointer-events:none!important;z-index:-1!important;border:0!important;padding:0!important;margin:0!important;">';
                
                var kl_start_time = Date.now();
                var kl_time_field = '<input type="hidden" name="form_start_time" value="' + kl_start_time + '">';
                
                kl_form.prepend( kl_honeypot + kl_time_field );
                
                kl_form.on( 'submit', function(e) {
                    var kl_honeypot_value = kl_form.find( '.emuaid-honeypot' ).val();
                    var kl_current_time = Date.now();
                    var kl_form_start = parseInt( kl_form.find( 'input[name="form_start_time"]' ).val() );
                    var kl_time_diff = kl_current_time - kl_form_start;
                    
                    if( kl_honeypot_value && kl_honeypot_value.trim() !== '' ) {
                        e.preventDefault();
                        return false;
                    }
                    
                    if( kl_time_diff < 2000 ) {
                        e.preventDefault();
                        return false;
                    }
                });
            });
            
            clearInterval( klaviyo_honeypot_interval );
        } else {
            klaviyo_honeypot_timeout++;
        }
    }
});

// ARIA Link Fix
$(document).ready(function(){
  var fixAria = setInterval(function(){
    if($('.jdgm-random-link.jdgm-hidden').length) {
      $('.jdgm-random-link.jdgm-hidden').attr('aria-hidden', 'true').attr('aria-label', 'Hidden Link');
      clearInterval(fixAria);
    }
  }, 200);

  setTimeout(function(){
    clearInterval(fixAria);
  }, 10000);
});
// END ARIA Link Fix

// Anchor Navigation - Mobile Scrollable
$(document).ready(function(){
    if ($('.anchor-nav-list').length) {
        function isMobile() {
            return window.innerWidth <= 798;
        }
        
        $('.anchor-nav-list a').on('click', function(e) {
            $('.anchor-nav-list a').removeClass('active');
            $(this).addClass('active');
            
            if (isMobile()) {
                var $navList = $('.anchor-nav-list');
                var $clickedItem = $(this).parent();
                var scrollPosition = $clickedItem.get(0).offsetLeft - 16; // 16px for padding
                
                $navList.scrollLeft(scrollPosition);
            }
        });
        
        $(window).on('resize', function() {
            if (!isMobile()) {
                $('.anchor-nav-list').scrollLeft(0);
            }
        });
    }
});

// Scroll to Top Button
$(document).ready(function(){
    if ($('#scroll-to-top').length) {
        var $scrollToTopBtn = $('#scroll-to-top');
        
        $(window).on('scroll', function() {
            if ($(window).scrollTop() > 200) {
                $scrollToTopBtn.addClass('show');
            } else {
                $scrollToTopBtn.removeClass('show');
            }
        });
        
        $scrollToTopBtn.on('click', function() {
            if (window.disableStickyHeader) {
                window.disableStickyHeader();
            }
            
            $('html, body').animate({
                scrollTop: 0
            }, 800, function() {
                if (window.enableStickyHeader) {
                    window.enableStickyHeader();
                }
            });
        });
    }

    function initFAQAccordion() {
        $('.faq-accordion__summary').on('click', function(e) {
            e.preventDefault();
            
            var $summary = $(this);
            var $details = $summary.closest('.faq-accordion__details');
            var $item = $summary.closest('.faq-accordion__item');
            var $allItems = $('.faq-accordion__item');
            
            var currentIndex = $allItems.index($item);
            var currentRow = Math.floor(currentIndex / 2);
            
            $allItems.each(function(index) {
                var itemRow = Math.floor(index / 2);
                if (itemRow !== currentRow) {
                    var $otherDetails = $(this).find('.faq-accordion__details');
                    $otherDetails.removeAttr('open');
                }
            });
            
            $details.attr('open', $details.attr('open') ? null : '');
        });
    }

    initFAQAccordion();
});

var header = {
  initialized: false,
  init: function() {
    if (header.initialized) return;
    
    setTimeout(function() {
      header.initMegaMenu();
      header.initSearchForm();
      header.initAnnouncementBanner();
      header.initKeyboardNavigation();
      header.initStickyHeader();
      header.initMobileNavigation();
      header.initialized = true;
    }, 100);
  },

  initMegaMenu: function() {
    var $megaMenuTriggers = $('.header .nav-link[aria-haspopup="true"]');
    var $megaMenus = $('.mega-menu-dropdown');
    var $dropdownWrappers = $('.drop-down-wrapper');
    var $body = $('body');
    var hoverTimeout;

    $megaMenuTriggers.each(function() {
      var $trigger = $(this);
      var menuHandle = $trigger.find('.mega-menu-placeholder').data('menu');
      var $megaMenu = $('#mega-menu-' + menuHandle);
      var $dropdownWrapper = $trigger.siblings('.drop-down-wrapper');
      
       var hasMegaMenuBlock = $megaMenu.length > 0;
       var hasDropdownWrapper = $dropdownWrapper.length > 0;
       

      $trigger.on('mouseenter', function() {
        clearTimeout(hoverTimeout);
        
        if (hasMegaMenuBlock) {
          header.showMegaMenu($megaMenu, $trigger);
          $dropdownWrappers.removeClass('show').attr('aria-hidden', 'true');
        } else if (hasDropdownWrapper) {
          header.showDropdown($dropdownWrapper, $trigger);
          $megaMenus.removeClass('show').attr('aria-hidden', 'true');
        }
      });

      $trigger.on('mouseleave', function() {
        hoverTimeout = setTimeout(function() {
          if (hasMegaMenuBlock) {
            header.hideMegaMenu($megaMenu, $trigger);
          } else if (hasDropdownWrapper) {
            header.hideDropdown($dropdownWrapper, $trigger);
          }
        }, 150);
      });

      $trigger.on('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (hasMegaMenuBlock) {
            if ($megaMenu.hasClass('show')) {
              header.hideMegaMenu($megaMenu, $trigger);
            } else {
              header.showMegaMenu($megaMenu, $trigger);
            }
          } else if (hasDropdownWrapper) {
            if ($dropdownWrapper.hasClass('show')) {
              header.hideDropdown($dropdownWrapper, $trigger);
            } else {
              header.showDropdown($dropdownWrapper, $trigger);
            }
          }
        } else if (e.key === 'Escape') {
          if (hasMegaMenuBlock) {
            header.hideMegaMenu($megaMenu, $trigger);
          } else if (hasDropdownWrapper) {
            header.hideDropdown($dropdownWrapper, $trigger);
          }
          $trigger.focus();
        }
      });
    });

    $megaMenus.on('mouseenter', function() {
      clearTimeout(hoverTimeout);
      $(this).addClass('show').attr('aria-hidden', 'false');
    });

    $megaMenus.on('mouseleave', function() {
      var $megaMenu = $(this);
      hoverTimeout = setTimeout(function() {
        $megaMenu.removeClass('show').attr('aria-hidden', 'true');
        $megaMenuTriggers.attr('aria-expanded', 'false');
        $body.removeClass('mega-menu-open');
      }, 150);
    });

    $dropdownWrappers.on('mouseenter', function() {
      clearTimeout(hoverTimeout);
      $(this).addClass('show').attr('aria-hidden', 'false');
    });

    $dropdownWrappers.on('mouseleave', function() {
      var $dropdown = $(this);
      hoverTimeout = setTimeout(function() {
        $dropdown.removeClass('show').attr('aria-hidden', 'true');
      }, 150);
    });

    $(document).on('click', function(e) {
      if (!$(e.target).closest('.mega-menu-dropdown, .drop-down-wrapper, .nav-link[aria-haspopup="true"]').length) {
        $megaMenus.removeClass('show').attr('aria-hidden', 'true');
        $dropdownWrappers.removeClass('show').attr('aria-hidden', 'true');
        $megaMenuTriggers.attr('aria-expanded', 'false');
        $body.removeClass('mega-menu-open');
      }
    });
  },

  showMegaMenu: function($megaMenu, $trigger) {
    $('.mega-menu-dropdown').removeClass('show').attr('aria-hidden', 'true');
    $('.drop-down-wrapper').removeClass('show').attr('aria-hidden', 'true');
    $('.nav-link[aria-haspopup="true"]').attr('aria-expanded', 'false');
    
    $megaMenu.addClass('show').attr('aria-hidden', 'false');
    $trigger.attr('aria-expanded', 'true');
    $('body').addClass('mega-menu-open');

    setTimeout(function() {
      var $firstLink = $megaMenu.find('a').first();
      if ($firstLink.length) {
        $firstLink.focus();
      }
    }, 100);
  },

  hideMegaMenu: function($megaMenu, $trigger) {
    $megaMenu.removeClass('show').attr('aria-hidden', 'true');
    $trigger.attr('aria-expanded', 'false');
    $('body').removeClass('mega-menu-open');
  },

  showDropdown: function($dropdown, $trigger) {
    $('.mega-menu-dropdown').removeClass('show').attr('aria-hidden', 'true');
    $('.drop-down-wrapper').removeClass('show').attr('aria-hidden', 'true');
    $('.nav-link[aria-haspopup="true"]').attr('aria-expanded', 'false');
    
    $dropdown.addClass('show').attr('aria-hidden', 'false');
    $trigger.attr('aria-expanded', 'true');

    setTimeout(function() {
      var $firstLink = $dropdown.find('a[role="menuitem"]').first();
      if ($firstLink.length) {
        $firstLink.focus();
      }
    }, 100);
  },

  hideDropdown: function($dropdown, $trigger) {
    $dropdown.removeClass('show').attr('aria-hidden', 'true');
    $trigger.attr('aria-expanded', 'false');
  },

  initSearchForm: function() {
    $('.desktop-header .search-toggle').off('click.searchToggle');
    $('.mobile-header .search-toggle').off('click.searchToggle');
    
    $('.desktop-header .search-toggle').on('click.searchToggle', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var $searchField = $('.desktop-search-field-container');
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      
      if (isExpanded) {
        $searchField.removeClass('show');
        $(this).attr('aria-expanded', 'false');
      } else {
        $searchField.addClass('show');
        $(this).attr('aria-expanded', 'true');
        
        var $searchInput = $searchField.find('input[name="q"]');
        if ($searchInput.length) {
          setTimeout(function() {
            $searchInput.focus();
          }, 100);
        }
      }
    });
      
    $('.mobile-header .search-toggle').on('click.searchToggle', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      var $searchField = $('.mobile-search-field-container');
      var isExpanded = $(this).attr('aria-expanded') === 'true';
      
      if (isExpanded) {
        $searchField.removeClass('show');
        $(this).attr('aria-expanded', 'false');
      } else {
        $searchField.addClass('show');
        $(this).attr('aria-expanded', 'true');
        
        var $searchInput = $searchField.find('input[name="q"]');
        if ($searchInput.length) {
          setTimeout(function() {
            $searchInput.focus();
          }, 100);
        }
      }
    });
    
    $(document).on('click', function(e) {
      if (!$(e.target).closest('.search-container').length) {
        $('.mobile-search-field-container, .desktop-search-field-container').removeClass('show');
        $('.search-toggle').attr('aria-expanded', 'false');
      }
    });
    
    $(document).on('keydown', function(e) {
      if (e.key === 'Escape') {
        $('.mobile-search-field-container, .desktop-search-field-container').removeClass('show');
        $('.search-toggle').attr('aria-expanded', 'false');
      }
    });
    
    $('.search__form').on('submit', function(e) {
      var $searchInput = $(this).find('input[name="q"]');
      if (!$searchInput.val().trim()) {
        e.preventDefault();
      }
    });
    
  },

  initAnnouncementBanner: function() {
    var $banner = $('.announcement-banner');
    var $closeButton = $banner.find('.announcement-banner__close');

    $closeButton.on('click', function() {
      $banner.slideUp(300, function() {
        $banner.remove();
        $(document).trigger('announcementBannerClosed');
      });
    });

    $closeButton.on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
      }
    });

    $(document).on('keydown', function(e) {
      if (e.key === 'Escape' && $banner.is(':visible')) {
        $closeButton.click();
      }
    });

    if ($banner.length) {
      $banner.attr('tabindex', '-1');
      $banner.attr('role', 'banner');
      $banner.attr('aria-live', 'polite');
    }
  },

  initKeyboardNavigation: function() {
    var $navLinks = $('.header .nav-link');
    var $megaMenuLinks = $('.mega-menu a');
    var $dropdownLinks = $('.drop-down-wrapper a[role="menuitem"]');

    $navLinks.on('keydown', function(e) {
      var $links = $navLinks;
      var currentIndex = $links.index(this);
      var $currentLink = $(this);
      
      switch(e.key) {
        case 'ArrowRight':
          e.preventDefault();
          var nextIndex = (currentIndex + 1) % $links.length;
          $links.eq(nextIndex).focus();
          break;
          
        case 'ArrowLeft':
          e.preventDefault();
          var prevIndex = currentIndex === 0 ? $links.length - 1 : currentIndex - 1;
          $links.eq(prevIndex).focus();
          break;
          
        case 'ArrowDown':
        case 'Enter':
        case ' ':
          e.preventDefault();
          if ($currentLink.attr('aria-haspopup') === 'true') {
            var menuHandle = $currentLink.find('.mega-menu-placeholder').data('menu');
            var $megaMenu = $('#mega-menu-' + menuHandle);
            var $dropdownWrapper = $currentLink.siblings('.drop-down-wrapper');
            
            
            if ($megaMenu.length) {
              header.showMegaMenu($megaMenu, $currentLink);
            } else if ($dropdownWrapper.length) {
              header.showDropdown($dropdownWrapper, $currentLink);
            }
          } else if ($currentLink.attr('href') && $currentLink.attr('href') !== '#') {
            window.location.href = $currentLink.attr('href');
          }
          break;
          
        case 'Home':
          e.preventDefault();
          $links.first().focus();
          break;
          
        case 'End':
          e.preventDefault();
          $links.last().focus();
          break;
      }
    });

    $megaMenuLinks.on('keydown', function(e) {
      var $megaMenu = $(this).closest('.mega-menu-dropdown');
      var $links = $megaMenu.find('a');
      var currentIndex = $links.index(this);
      var $currentLink = $(this);
      
      switch(e.key) {
        case 'ArrowDown':
          e.preventDefault();
          var nextIndex = (currentIndex + 1) % $links.length;
          $links.eq(nextIndex).focus();
          break;
          
        case 'ArrowUp':
          e.preventDefault();
          var prevIndex = currentIndex === 0 ? $links.length - 1 : currentIndex - 1;
          $links.eq(prevIndex).focus();
          break;
          
        case 'ArrowRight':
          e.preventDefault();
          var $currentSection = $currentLink.closest('.mega-menu-section');
          var $nextSection = $currentSection.next('.mega-menu-section');
          if ($nextSection.length) {
            $nextSection.find('a').first().focus();
          } else {
            $megaMenu.find('.mega-menu-section').first().find('a').first().focus();
          }
          break;
          
        case 'ArrowLeft':
          e.preventDefault();
          var $currentSection = $currentLink.closest('.mega-menu-section');
          var $prevSection = $currentSection.prev('.mega-menu-section');
          if ($prevSection.length) {
            $prevSection.find('a').first().focus();
          } else {
            $megaMenu.find('.mega-menu-section').last().find('a').first().focus();
          }
          break;
          
        case 'Escape':
          e.preventDefault();
          var menuId = $megaMenu.attr('id');
          var menuHandle = menuId.replace('mega-menu-', '');
          var $trigger = $('.nav-link').filter(function() {
            return $(this).find('.mega-menu-placeholder').data('menu') === menuHandle;
          });
          header.hideMegaMenu($megaMenu, $trigger);
          $trigger.focus();
          break;
          
        case 'Home':
          e.preventDefault();
          $links.first().focus();
          break;
          
        case 'End':
          e.preventDefault();
          $links.last().focus();
          break;
      }
    });

    $dropdownLinks.on('keydown', function(e) {
      var $dropdown = $(this).closest('.drop-down-wrapper');
      var $links = $dropdown.find('a[role="menuitem"]');
      var currentIndex = $links.index(this);
      var $currentLink = $(this);
      
      switch(e.key) {
        case 'ArrowDown':
          e.preventDefault();
          var nextIndex = (currentIndex + 1) % $links.length;
          $links.eq(nextIndex).focus();
          break;
          
        case 'ArrowUp':
          e.preventDefault();
          var prevIndex = currentIndex === 0 ? $links.length - 1 : currentIndex - 1;
          $links.eq(prevIndex).focus();
          break;
          
        case 'ArrowRight':
          e.preventDefault();
          var $currentWrapper = $currentLink.closest('.navigation-wrapper');
          var $nextWrapper = $currentWrapper.next('.navigation-wrapper');
          if ($nextWrapper.length) {
            $nextWrapper.find('a[role="menuitem"]').first().focus();
          } else {
            $dropdown.find('.navigation-wrapper').first().find('a[role="menuitem"]').first().focus();
          }
          break;
          
        case 'ArrowLeft':
          e.preventDefault();
          var $currentWrapper = $currentLink.closest('.navigation-wrapper');
          var $prevWrapper = $currentWrapper.prev('.navigation-wrapper');
          if ($prevWrapper.length) {
            $prevWrapper.find('a[role="menuitem"]').first().focus();
          } else {
            $dropdown.find('.navigation-wrapper').last().find('a[role="menuitem"]').first().focus();
          }
          break;
          
        case 'Escape':
          e.preventDefault();
          var $trigger = $dropdown.siblings('.nav-link');
          header.hideDropdown($dropdown, $trigger);
          $trigger.focus();
          break;
          
        case 'Home':
          e.preventDefault();
          $links.first().focus();
          break;
          
        case 'End':
          e.preventDefault();
          $links.last().focus();
          break;
      }
    });

    $('.js-nav-control').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
      }
    });

    $('.search-toggle').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).click();
      }
    });

    $('.mini_cart').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.location.href = $(this).attr('href');
      }
    });

    $('.header__heading-link').on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        window.location.href = $(this).attr('href');
      }
    });
  },

  initStickyHeader: function() {
    var $header = $('.header');
    var $headerWrapper = $('.header-wrapper');
    var $body = $('body');
    var $main = $('body main');
    var $announcementBanner = $('.announcement-banner');
    var topBarHeight = $('.top-bar').outerHeight();
    var isSticky = false;
    var ticking = false;
    var lastScrollTop = 0;
    var isProgrammaticScroll = false;

    if ($header.hasClass('disable-sticky')) {
      return;
    }

    window.disableStickyHeader = function() {
      isProgrammaticScroll = true;
      $headerWrapper.addClass('transitioning');
    };
    
    window.enableStickyHeader = function() {
      isProgrammaticScroll = false;
      $headerWrapper.removeClass('transitioning');
      lastScrollTop = $(window).scrollTop();
      updateStickyHeader();
    };

    var $placeholder = $('<div class="header-placeholder"></div>');
    
    function getTotalPaddingHeight() {
      var announcementHeight = $announcementBanner.length ? $announcementBanner.outerHeight() : 0;
      return $headerWrapper.outerHeight();
    }

    function calculateStickyThreshold() {
      var announcementHeight = $announcementBanner.length ? $announcementBanner.outerHeight() : 0;
      return announcementHeight + topBarHeight;
    }

    var stickyTreshold = calculateStickyThreshold();
    
    function updateStickyHeader() {
      if (isProgrammaticScroll) {
        ticking = false;
        return;
      }
      
      var scrollTop = lastScrollTop;
      
      if (scrollTop >= stickyTreshold && !isSticky) {
        var headerHeight = $headerWrapper.outerHeight();
        var totalPaddingHeight = getTotalPaddingHeight();
        $main.css('padding-top', totalPaddingHeight + 'px');
        $placeholder.height(headerHeight);
        $headerWrapper.before($placeholder);
        $headerWrapper.addClass('sticky');
        $header.addClass('header-scrolled');
        $body.addClass('has-sticky-header');
        isSticky = true;
      } else if (scrollTop < stickyTreshold && isSticky) {
        $main.css('padding-top', '0');
        $headerWrapper.removeClass('sticky');
        $header.removeClass('header-scrolled');
        $body.removeClass('has-sticky-header');
        $placeholder.remove();
        isSticky = false;
      }
      
      ticking = false;
    }
    
    function requestTick() {
      if (!ticking && !isProgrammaticScroll) {
        window.requestAnimationFrame(updateStickyHeader);
        ticking = true;
      }
    }
    
    $(window).on('scroll', function() {
      lastScrollTop = $(window).scrollTop();
      requestTick();
    });

    $(window).on('resize', function() {
      stickyTreshold = calculateStickyThreshold();
      
      if (isSticky) {
        var headerHeight = $headerWrapper.outerHeight();
        var totalPaddingHeight = getTotalPaddingHeight();
        
        $placeholder.height(headerHeight);
        $main.css('padding-top', totalPaddingHeight + 'px');
      }
    });

    $(document).on('announcementBannerClosed', function() {
      stickyTreshold = calculateStickyThreshold();
      
      if (isSticky && $(window).scrollTop() < stickyTreshold) {
        $main.css('padding-top', '0');
        $headerWrapper.removeClass('sticky');
        $header.removeClass('header-scrolled');
        $body.removeClass('has-sticky-header');
        $placeholder.remove();
        isSticky = false;
      }
    });

    $(document).on('announcementBannerToggle', function() {
      stickyTreshold = calculateStickyThreshold();
    });
  },

    initMobileNavigation: function() {
      var retryCount = 0;
      var maxRetries = 3;
      
      function setupMobileNavigation() {
        if ($('.mobile-nav-menu').length === 0) {
          if (retryCount < maxRetries) {
            retryCount++;
            setTimeout(setupMobileNavigation, 500);
            return;
          }
          return;
        }
        
        $('.hamburger, .js-nav-control').off('click.mobileNav').on('click.mobileNav', function(e) {
          e.preventDefault();
          $('.mobile-nav-menu, .mobile-nav-overlay').addClass('show');
          $('body').css('overflow', 'hidden');
        });
        
        function closeMobileNav() {
          $('.mobile-nav-menu, .mobile-nav-overlay').removeClass('show');
          $('body').css('overflow', '');
        }
        
        $('.mobile-nav-close, .mobile-nav-overlay').off('click.mobileNav').on('click.mobileNav', closeMobileNav);
        
        $('.mobile-nav-menu').off('click.mobileNavClick').on('click.mobileNavClick', function(e) {
          if (!$(e.target).closest('.mobile-nav-search-container').length) {
            $('.mobile-nav-search-field-container').removeClass('show');
            $('.mobile-nav-search').attr('aria-expanded', 'false');
          }
        });
        
        $('.mobile-nav-search').off('click.mobileNav').on('click.mobileNav', function(e) {
          e.preventDefault();
          var $searchField = $('.mobile-nav-search-field-container');
          var isExpanded = $(this).attr('aria-expanded') === 'true';
          
          if (isExpanded) {
            $searchField.removeClass('show');
            $(this).attr('aria-expanded', 'false');
          } else {
            $searchField.addClass('show');
            $(this).attr('aria-expanded', 'true');
            setTimeout(function() {
              $searchField.find('input[name="q"]').focus();
            }, 100);
          }
        });
        
        $(document).off('click.mobileNavToggle').on('click.mobileNavToggle', '.mobile-nav-toggle', function(e) {
          e.preventDefault();
          
          var $this = $(this);
          var isExpanded = $this.attr('aria-expanded') === 'true';
          var $content = $('#' + $this.attr('aria-controls'));
          
          $('.mobile-nav-toggle').not($this).attr('aria-expanded', 'false');
          $('.mobile-nav-content-section').not($content).attr('aria-hidden', 'true');
          
          $this.attr('aria-expanded', !isExpanded);
          $content.attr('aria-hidden', isExpanded);
        });

        $(document).off('click.mobileNavDropdown').on('click.mobileNavDropdown', '.mobile-nav-dropdown-section-toggle', function(e) {
          e.preventDefault();
          
          var $this = $(this);
          var isExpanded = $this.attr('aria-expanded') === 'true';
          var $content = $('#' + $this.attr('aria-controls'));
          
          $this.attr('aria-expanded', !isExpanded);
          $content.attr('aria-hidden', isExpanded);
        });
      }
      
      setupMobileNavigation();
    }
};

$(document).ready(function() {
  header.init();
});
</i.length;r++){var></this.selectors.length;e++){var></t.length;o++)e(t[o],o)},shopify.map=function(t,e){for(var></product.variants.length;></li></section>